import type { BuckChatVariant, BuckChatWelcomeContent, PageType } from '../../types';
import BaseEmptyState from './BaseEmptyState';
import HomepageEmptyState from './HomepageEmptyState';
import ListingEmptyState, { LISTING_EMPTY_STATE_DEFAULTS } from './ListingEmptyState';
import PackageEmptyState, { PACKAGE_EMPTY_STATE_DEFAULTS } from './PackageEmptyState';

type EmptyStateProps = {
  content?: BuckChatWelcomeContent;
  disabled?: boolean;
  onPromptClick?: (prompt: string) => void;
  pageType?: PageType;
  starterPromptsTitle?: string;
  variant: BuckChatVariant;
};

export const DEFAULT_EMPTY_STATE_CONTENT: BuckChatWelcomeContent = {
  heading: 'Have a question?',
  introBody:
    'I can answer questions about this package - species, seasons, rules, access, and more. What would you like to know?',
};

export const getEmptyStateDefaultContent = ({
  pageType,
  variant,
}: {
  pageType?: PageType;
  variant: BuckChatVariant;
}): BuckChatWelcomeContent | undefined => {
  if (variant === 'homepage') {
    return undefined;
  }

  if (pageType === 'listing') {
    return LISTING_EMPTY_STATE_DEFAULTS;
  }

  if (pageType === 'package') {
    return PACKAGE_EMPTY_STATE_DEFAULTS;
  }

  return undefined;
};

const EmptyState = ({
  content,
  disabled,
  onPromptClick,
  pageType,
  starterPromptsTitle,
  variant,
}: EmptyStateProps) => {
  if (variant === 'homepage') {
    return (
      <HomepageEmptyState
        content={content}
        disabled={disabled}
        onPromptClick={onPromptClick}
        starterPromptsTitle={starterPromptsTitle}
      />
    );
  }

  if (pageType === 'listing') {
    return <ListingEmptyState content={content} />;
  }

  if (pageType === 'package') {
    return <PackageEmptyState content={content} />;
  }

  return <BaseEmptyState content={content} defaultContent={DEFAULT_EMPTY_STATE_CONTENT} />;
};

export default EmptyState;
